import { useState } from 'react'
import ReactJson from 'react-json-view'
import ApiRoute from '../../components/ApiRoute'
import PlansModal from './plans-modal'

const HistoryItem = ({ data, isOpen, setOpen, providers }) => {
  const [showPlans, setShowPlans] = useState(false)
  const status = data.response?.status
  const statusColor = status >= 500 ? 'bg-red-500' : status >= 400 ? 'bg-yellow-500' : status >= 200 && status < 300 ? 'bg-green-500' : 'bg-gray-400'

  // Only show plans button for plans/predictPlans routes
  const route = data.request?.route || ''
  const isPlansRoute = route.includes('/plans') || route.includes('/predictPlans')

  // predictPlans: body has { plans, total }
  // basicPlans: body is an array of plans directly
  const body = data.response?.body
  const plans = isPlansRoute ? (Array.isArray(body) ? body : body?.plans) : null
  const total = isPlansRoute ? (Array.isArray(body) ? body.length : body?.total) : null
  const hasPlans = isPlansRoute && status >= 200 && status < 300 && plans && plans.length > 0

  const exportJson = (e) => {
    e.stopPropagation()
    const json = JSON.stringify(data, null, 2)
    const blob = new Blob([json], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const downloadLink = document.createElement('a')
    downloadLink.href = url
    downloadLink.download = `${data.request.method}_${data.request.route.replace(/\//g, '_')}.json`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  return (
    <div className='flex flex-col border-b border-gray-200'>
      <div className='flex items-center justify-between'>
        <ApiRoute onClick={setOpen} method={data.request.method} route={data.request.route} />
        <div className='flex items-center gap-2'>
          {hasPlans && (
            <button
              onClick={(e) => { e.stopPropagation(); setShowPlans(true) }}
              className='text-xs text-blue-600 hover:text-blue-800 px-2 py-1 border border-blue-300 rounded hover:bg-blue-50'
            >
              Show Plans ({plans.length})
            </button>
          )}
          {status && <span className={`${statusColor} text-white text-xs px-2 py-0.5 rounded font-mono`}>{status}</span>}
          <button
            onClick={exportJson}
            className='text-xs text-gray-500 hover:text-gray-700 px-2 py-1 border border-gray-300 rounded hover:bg-gray-100'
          >
            Export
          </button>
        </div>
      </div>
      {isOpen && (
        <div className='text-xs m-2 text-left'>
          <ReactJson src={data} theme='monokai' enableClipboard />
        </div>
      )}
      {showPlans && <PlansModal plans={plans} total={total} providers={providers} onClose={() => setShowPlans(false)} />}
    </div>
  )
}

export default HistoryItem
